module.exports = __parcel__import__.meta.resolve("8X7Cx");